import styled from '@emotion/styled'
import { Accordion, AccordionDetails, AccordionSummary, css } from '@mui/material'
import { Card } from 'components'
import { theme } from 'styles/theme/hav-theme'

export const CardFilter = styled(Card)`
  margin-bottom: ${theme.spacing.sm};
`

export const AccordionFilter = styled(Accordion)`
  box-shadow: none;
  display: flex;
  flex-direction: column;
`

export const Form = styled('form')`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const FormHeader = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${theme.spacing.lg};
`

export const WrapFormTitle = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const FormTitle = styled('h1')`
  margin: 0;
  font-family: ${theme.typography.family.bold};
  font-size: ${theme.typography.sizes['2md']};
  color: ${theme.colors.neutral.black};
  font-weight: ${theme.typography.weight.lg};
`

export const FormActions = styled('div')`
  display: flex;
  align-items: center;
  gap: ${theme.spacing['2xm']};
`

export const FormContent = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
  box-shadow: none;
`

export const AccordionButton = styled(AccordionSummary)`
  display: flex;
  flex-direction: row-reverse;
  gap: ${theme.spacing.xs};
  height: ${theme.spacing.xl};
  min-height: ${theme.spacing.xl};
  color: ${theme.colors.primary.main};
  font-size: ${theme.typography.sizes.xs};
  padding: 0 ${theme.spacing.md};

  &.Mui-expanded {
    min-height: ${theme.spacing.xl};
  }
`

export const AccordionContent = styled(AccordionDetails)`
  display: flex;
  padding: 0;
  flex-direction: column;
  gap: ${theme.spacing.md};
  margin-top: ${theme.spacing.lg};
`

export const TextAccordionButton = styled('span')`
  font-family: ${theme.typography.family.bold};
  color: ${theme.colors.primary.main};
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.xs};
`

export const WrapToggleHierarchy = styled('div')`
  display: flex;
  align-items: center;
  height: ${theme.spacing.xl};
`

export const ToggleHierarchyText = styled('label')`
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.xs};
`

export const FormRow = styled('div')`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  row-gap: ${theme.spacing.md};

  &.flexEnd {
    justify-content: flex-end;
  }
`

export const FormColumn = styled('div')`
  max-width: 16%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  &.lineColumn {
    align-items: flex-end;
    flex-direction: row;
    gap: 8px;
  }

  @media only screen and (max-width: ${theme.breakpoints.md}px) {
    max-width: 32%;
  }
`

type LabelFilterProps = { disabled?: boolean }

export const LabelFilter = styled('div')<LabelFilterProps>`
  color: ${theme.colors.neutral.medium};
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.xs};
  display: flex;
  gap: ${theme.spacing.xs};
  align-items: center;

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${theme.colors.neutral.medium};
    `}
`

export const SubColumn = styled('div')`
  display: flex;
  margin-right: ${theme.spacing.md};
  flex-direction: column;
  justify-content: flex-end;
`
